<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
      <el-input size="small" @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item" :placeholder="'名称'"
        v-model="listQuery[nameKey]">
      </el-input>
      <el-button  class="filter-item"  size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
            </div>
    </sticky>
      <div class="app-container flex-item flex-column">
       <div class="flex-item">
      <el-table class="demo-card fh" ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit height="calc(45vh - 52px)"
        highlight-current-row style="width: 100%;" @row-click="rowClick" >

        <el-table-column align="center" width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" :label="scope.$index">&thinsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width" :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false" :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]" v-if="item.isSel">
              </select-type>
              <span v-else>
                <span v-if="item.type === 'DateTime'&&item.key !== 'createTime'">{{scope.row[item.key] | dateFormat}}</span>
                <span v-else>{{scope.row[item.key]}}</span>
              </span>
            </template>
          </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    </div>
    <div class="el-dialog__footer">
      <el-button size="mini" @click="close">取消</el-button>
      <el-button size="mini" type="primary" @click="submit">确认</el-button>
    </div>
    </div>
  </div>

</template>

<script>
// import * as cmschances from '@/api/cmschances'
import request from '@/utils/request';
import { parseTime } from '@/utils/index';
import waves from '@/directive/waves'; // 水波纹指令
import Pagination from '@/components/Pagination';
import SelectType from '@/components/SelectType';
import Sticky from '@/components/Sticky';
import { mapGetters } from 'vuex';

export default {
  name: 'select-new',
  components: {
    Pagination, SelectType, Sticky
  },
  directives: {
    waves
  },
  props: {
    idKey: [String],
    nameKey: [String],
    otherQuery: {
      type: Array,
      // default() {
      //   return []
      // }
      default() {
        return [{
          key: '',
          relation: '',
          value: ''
        }];
      }
    },
    returnKey: {
      type: Array,
      default() {
        return [{
          querykey: '',
          modelkey: ''
        }];
      }
    },
    getDataMethod: {
      type: String,
      default: 'load'
    },
    apiName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      radioVal: '',
      headerList: [],
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        name: undefined,
        appId: undefined,
        wheres: ''
      }
    };
  },
  filters: {

    dateFormat(datetitme) { // 时间格式化
      return datetitme ? parseTime(new Date(datetitme), '{y}-{m}-{d}') : '';
    }
  },
  created() {
    // this.listQuery = { ...this.listQuery, ...this.parmObj }
    this.getList();
  },
  watch: {
    otherQuery() {
      this.getList();
    }
  },
  computed: {
    ...mapGetters(['currentAccId'])
  },
  methods: {
    rowClick(row) {
      this.radioVal = this.list.indexOf(row);
    },
    getListByApi(data) {
      return request({
        url: '/' + this.apiName + '/' + this.getDataMethod,
        method: 'post',
        data
      });
    },
    getList() {
      const _this = this;
      this.listLoading = true;
      const tempotherQuery = _this.otherQuery.filter(m =>
        m.key && m.key !== '' && m.value && m.value !== ''
      );

      const wheresObj = [];
      if (tempotherQuery.length > 0) {
        tempotherQuery.forEach(item => {
          wheresObj.push({
            field: item.key,
            value: item.value === '{{AccountId}}' ? this.currentAccId : item.value,
            relation: item.relation ? item.relation : '=='
          });
        });
      }
      wheresObj.push({
        field: this.nameKey,
        value: this.listQuery[this.nameKey],
        relation: 'contains'
      });
      _this.listQuery.wheres = JSON.stringify(wheresObj);
      _this.listQuery.AccountId = this.currentAccId;
      _this.getListByApi(_this.listQuery).then(response => {
        _this.list = response.data;
        response.columnHeaders.forEach((item) => {
          item.key = item.key.substring(0, 1).toLowerCase() + item.key.substring(1);
        });
        _this.headerList = response.columnHeaders.filter(u => u.browsable);
        _this.total = response.count;
        _this.listLoading = false;
      });
    },
    handleFilter() {
      this.radioVal = '';
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.radioVal !== null && this.radioVal !== undefined && this.radioVal !== '') {
        const tempobj = {};
        tempobj.name = this.list[this.radioVal][this.nameKey];
        tempobj.id = this.list[this.radioVal][this.idKey];

        this.returnKey.filter(m => m.querykey !== '' && m.modelkey !== '').forEach(m => {
          tempobj[m.modelkey] = this.list[this.radioVal][m.querykey];
        });

        console.log(8, this.returnKey, tempobj);
        tempobj.list = this.list;
        this.$emit('closeMoule', tempobj);
      } else {
        this.$alert('请选择记录!', '', {
          confirmBuwarningttonText: '确定',
          type: 'warning',
          center: 'true'
        });
        return;
      }
    }
  }
};
</script>
<style>
.configDiv1 {
  width:100%;
  position:relative;
}
.configDiv2 {
  width:230px;
}
#newbutton {
  position: absolute;
  top: -1px;
  left: 240px;
}
</style>
